import React from 'react';
import styled from 'styled-components';

const VideoBase = styled.video.attrs((props) => ({
  style: { ...props.style }
}))`${(props) => props.computedStyle}`;

const VideoGradient = styled.div`
  background: radial-gradient(#323a45, #1a1f24);
  height: 100%;
  mix-blend-mode: multiply;
  opacity: 0.75;
  position: absolute;
  width: 100%;
  z-index: 1;
`;











const NoControlsPlayer = (props) => {
  const { video, style, computedStyle } = props;
  const { source } = video;

  return (
    <>
      <VideoGradient />
      <VideoBase key={source} loop muted autoPlay style={style} computedStyle={computedStyle}>
        <source src={source} />
      </VideoBase>
    </>);

};

export default NoControlsPlayer;